import { render, staticRenderFns } from "./SysAdmin.vue?vue&type=template&id=1a238e40&scoped=true&"
import script from "./SysAdmin.vue?vue&type=script&lang=js&"
export * from "./SysAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SysAdmin.vue?vue&type=style&index=0&id=1a238e40&scoped=true&lang=css&"
import style2 from "./SysAdmin.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a238e40",
  null
  
)

export default component.exports